import { useEffect } from 'react';
import { SITE_URL } from '../config/env.js';

const DEFAULT_OG = `${SITE_URL || 'https://repatikosam.com'}/og-image.png`;

function upsertMeta(attr, key, content) {
  if (!content || typeof document === 'undefined') return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/** Set document title + description + Open Graph tags (SPA routes). */
export function usePageMeta({ title, description, path = '', image = '', enabled = true }) {
  useEffect(() => {
    if (!enabled) return undefined;
    const base = (SITE_URL || 'https://repatikosam.com').replace(/\/$/, '');
    const url = path ? `${base}${path.startsWith('/') ? path : `/${path}`}` : base;
    const ogImage = image
      ? (image.startsWith('http') ? image : `${base}${image.startsWith('/') ? image : `/${image}`}`)
      : DEFAULT_OG;
    const prevTitle = document.title;

    document.title = title;
    upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:image', ogImage);
    upsertMeta('property', 'og:image:secure_url', ogImage);
    upsertMeta('property', 'og:type', image ? 'article' : 'website');
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', ogImage);

    return () => {
      document.title = prevTitle;
    };
  }, [title, description, path, image, enabled]);
}
